import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=22c1c71c&scoped=true"
import script from "./modify.vue?vue&type=script&lang=js"
export * from "./modify.vue?vue&type=script&lang=js"
import style0 from "./modify.vue?vue&type=style&index=0&id=22c1c71c&prod&scoped=true&lang=css"
import style1 from "./modify.vue?vue&type=style&index=1&id=22c1c71c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1c71c",
  null
  
)

export default component.exports